import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import "./CustomPopupModal.css";

// Reusable modal with a fixed header, scrollable body, and optional footer. Accepts open, onClose, title, children, footer, width, height, and maxHeight props.
export default function CustomPopupModal({
  open,
  onClose,
  title,
  children,
  footer,
  width = "480px",
  height = "auto",
  maxHeight = "80vh",
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <div
        className="cpm-overlay"
        style={{
          "--cpm-width": width,
          "--cpm-height": height,
          "--cpm-max-height": maxHeight,
        }}
      >
        <div className="cpm-header">
          <span className="cpm-title">{title}</span>
          <button className="cpm-close-btn" onClick={onClose} aria-label="Close modal">
            <CloseIcon fontSize="small" />
          </button>
        </div>

        <div className="cpm-body">{children}</div>

        {footer && <div className="cpm-footer">{footer}</div>}
      </div>
    </Modal>
  );
}
